import TwoLineEllipsis from "./TwoLineEllipsesWrapper";

export default TwoLineEllipsis;